module.exports = __webpack_public_path__ + "static/img/alessia.51c95025.png";